// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import AnneescolaireService from '../../services/AnneescolaireService';
import EmploidutempsService from '../../services/EmploidutempsService';
import MatiereService from '../../services/MatiereService';
import CompetenceService from '../../services/CompetenceService';
import SalledeclasseService from '../../services/SalledeclasseService';
import ExamenService from '../../services/ExamenService';

const OffcanvasAddEmploidutempsForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [matiereOptions, setMatiereOptions] = useState([]);
	const [competenceOptions, setCompetenceOptions] = useState([]);
	const [salledeclasseOptions, setSalledeclasseOptions] = useState([]);
	const [examenOptions, setExamenOptions] = useState([]);
	const [selectedSalleDeclasse, setSelectedSalleDeclasse] = useState(null);
	const [selectedEventType, setSelectedEventType] = useState(null);
	const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

	const DAYS_CHOICES = [
		{ value: 1, label: 'Lundi' },
		{ value: 2, label: 'Mardi' },
		{ value: 3, label: 'Mercredi' },
		{ value: 4, label: 'Jeudi' },
		{ value: 5, label: 'Vendredi' },
		{ value: 6, label: 'Samedi' },
		{ value: 7, label: 'Dimanche' }
	];

	const TYPE_CHOICES = [
		{ value: 'cours', label: 'Cours' },
		{ value: 'pause', label: 'Pause' },
		{ value: 'conge', label: 'Congés' },
		{ value: 'examen', label: 'Examen' }
	];

	useEffect(() => {
		const fetchCurrentSchoolYear = async () => {
			try {
				const schoolYear = await AnneescolaireService.getCurrentAnneescolaire();
				setCurrentSchoolYear(schoolYear.data);
			} catch (error) {
				console.error(
					"Erreur lors de la récupération de l'année scolaire en cours:",
					error
				);
				alert(
					`Erreur lors de la récupération de l'année scolaire en cours. Détails de l'erreur : ${error.message}`
				);
			}
		};

		fetchCurrentSchoolYear();
	}, []);

	useEffect(() => {
		const fetchMatiereOptions = async () => {
			try {
				const matieres = await MatiereService.getMatiereOptions();
				setMatiereOptions(matieres);
			} catch (error) {
				console.error('Error fetching matieres options', error);
			}
		};

		fetchMatiereOptions();
	}, []);

	const MATIERE_CHOICES = matiereOptions;

	useEffect(() => {
		const fetchCompetenceOptions = async () => {
			try {
				const competences = await CompetenceService.getCompetenceOptions();
				setCompetenceOptions(competences);
			} catch (error) {
				console.error('Error fetching competences options', error);
			}
		};

		fetchCompetenceOptions();
	}, []);

	const COMPETENCE_CHOICES = competenceOptions;

	useEffect(() => {
		const fetchSalledeclasseOptions = async () => {
			try {
				const salledeclasses = await SalledeclasseService.getClassOptions();
				setSalledeclasseOptions(salledeclasses);
			} catch (error) {
				console.error('Error fetching salle de classes options', error);
			}
		};

		fetchSalledeclasseOptions();
	}, []);

	const SALLEDECLASSE_CHOICES = salledeclasseOptions;

	useEffect(() => {
		const fetchExamenOptions = async () => {
			try {
				const examens = await ExamenService.getExamenOptions();
				setExamenOptions(examens);
			} catch (error) {
				console.error('Error fetching examens options', error);
			}
		};

		fetchExamenOptions();
	}, []);

	const EXAMEN_CHOICES = examenOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const emploidutempsData = new FormData();

				if (currentSchoolYear === null) {
					alert(
						"Erreur lors de la récupération de l'année scolaire en cours. Veuillez réessayer plus tard."
					);
					return;
				}

				// Add all your form data to the FormData
				emploidutempsData.append('emploi_type', selectedEventType);
				emploidutempsData.append('jour', form.jour.value);

				if (form.heure_debut) {
					emploidutempsData.append('heure_debut', form.heure_debut.value);
				}

				if (form.heure_fin) {
					emploidutempsData.append('heure_fin', form.heure_fin.value);
				}

				if (form.date_debut_conge) {
					emploidutempsData.append(
						'date_debut_conge',
						form.date_debut_conge.value
					);
				}

				if (form.date_fin_conge) {
					emploidutempsData.append('date_fin_conge', form.date_fin_conge.value);
				}

				if (form.matiere) {
					emploidutempsData.append('matiere', form.matiere.value);
				}

				if (form.competence) {
					emploidutempsData.append('competence', form.competence.value);
				}

				emploidutempsData.append('examen', form.examen.value);
				emploidutempsData.append('salledeclasse', selectedSalleDeclasse);
				emploidutempsData.append('anneescolaire', currentSchoolYear.id);

				// Call the EmploidutempsService to create the emploidutemps
				const response = await EmploidutempsService.createEmploidutemps(
					emploidutempsData
				);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of emploidutempss
				window.location.href = '/pedagogie/planning';
			} catch (error) {
				console.error("Erreur lors de la création de l'emploi de temps", error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	const handleSalleDeclasseChange = (e) => {
		const selectedSalleDeclasse = e.target.value;

		setSelectedSalleDeclasse(Number(selectedSalleDeclasse));

		// Reset the feedback messages for matiere and competence when salle de classe changes
		setFeedbackMessages((prevMessages) => ({
			...prevMessages,
			matiere: '',
			competence: ''
		}));
	};

	const handleEventTypeChange = (e) => {
		const selectedEventType = e.target.value;
		setSelectedEventType(selectedEventType);
	};

	const renderMatiereField = () => {
		if (!selectedSalleDeclasse) return null;

		// You can customize this logic based on your specific use case for matiere and classe mapping
		const classesConcernedByMatiere = [12, 18]; // class_six, cm2
		if (classesConcernedByMatiere.includes(selectedSalleDeclasse)) {
			return (
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="matiere">Matière</Form.Label>
					<Form.Select
						name="matiere"
						isInvalid={!!feedbackMessages['matiere']}
						onChange={(e) => {
							const value = e.target.value;
							setFeedbackMessages((prevMessages) => ({
								...prevMessages,
								matiere: value
									? ''
									: "La matière sélectionnée n'est pas valide."
							}));
						}}
					>
						<option value="">Selectionner la matière prévue</option>
						{MATIERE_CHOICES.map((choice, index) => (
							<option key={index} value={choice.value}>
								{choice.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['matiere']}
					</Form.Control.Feedback>
				</Col>
			);
		}

		return null;
	};

	const renderCompetenceField = () => {
		if (!selectedSalleDeclasse) return null;

		// You can customize this logic based on your specific use case for competence and classe mapping
		const classesConcernedByCompetence = [13, 14, 15, 16, 17, 7, 8, 9, 10, 11]; // sil, cp, ce1, ce2, cm1, class_one, class_two, class_three, class_four, class_five
		if (classesConcernedByCompetence.includes(selectedSalleDeclasse)) {
			return (
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="competence">Compétence</Form.Label>
					<Form.Select
						name="competence"
						options={COMPETENCE_CHOICES}
						isInvalid={!!feedbackMessages['competence']}
						onChange={(e) => {
							const value = e.target.value;
							setFeedbackMessages((prevMessages) => ({
								...prevMessages,
								competence: value
									? ''
									: "La compétence sélectionnée n'est pas valide."
							}));
						}}
					>
						<option value="">Selectionner la compétence prévue</option>
						{COMPETENCE_CHOICES.map((choice, index) => (
							<option key={index} value={choice.value}>
								{choice.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['competence']}
					</Form.Control.Feedback>
				</Col>
			);
		}

		return null;
	};

	const renderHeureDebutFin = () => {
		if (!selectedEventType) return null;

		if (selectedEventType !== 'conge') {
			return (
				<Col xs={12} className="mb-3">
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="heure_debut">Heure début</Form.Label>
								<Form.Control
									name="heure_debut"
									type="time"
									id="heure_debut"
									isInvalid={!!feedbackMessages['heure_debut']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											heure_debut: e.target.value
												? ''
												: "L'heure selectionnée n'est pas valide."
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['heure_debut']}
								</Form.Control.Feedback>
							</Col>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="heure_fin">Heure fin</Form.Label>
								<Form.Control
									name="heure_fin"
									type="time"
									id="heure_fin"
									isInvalid={!!feedbackMessages['heure_fin']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											heure_fin: e.target.value
												? ''
												: "L'heure selectionnée n'est pas valide."
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['heure_fin']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>
			);
		}

		return null;
	};

	const renderDateDebutFinConges = () => {
		if (!selectedEventType) return null;

		if (selectedEventType === 'conge') {
			return (
				<Col xs={12} className="mb-3">
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="date_debut_conge">Début congés</Form.Label>
								<Form.Control
									name="date_debut_conge"
									type="date"
									id="date_debut_conge"
									isInvalid={!!feedbackMessages['date_debut_conge']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											date_debut_conge: e.target.value
												? ''
												: "La date selectionnée n'est pas valide."
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_debut_conge']}
								</Form.Control.Feedback>
							</Col>

							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="date_fin_conge">Fin congés</Form.Label>
								<Form.Control
									name="date_fin_conge"
									type="date"
									id="date_fin_conge"
									isInvalid={!!feedbackMessages['date_fin_conge']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											date_fin_conge: e.target.value
												? ''
												: "La date selectionnée n'est pas valide."
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['date_fin_conge']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>
			);
		}

		return null;
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				{/* Emploi type */}
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="emploi_type">
						Type d'événement<span className="text-danger">*</span>
					</Form.Label>
					<Form.Select
						name="emploi_type"
						id="emploi_type"
						required
						isInvalid={!!feedbackMessages['emploi_type']}
						onChange={handleEventTypeChange}
					>
						<option value="">Selectionner le type d'événement</option>
						{TYPE_CHOICES.map((option, index) => (
							<option key={index} value={option.value}>
								{option.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['emploi_type']}
					</Form.Control.Feedback>
				</Col>

				{/* Jour */}
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="jour">Jour</Form.Label>
					<Form.Select
						name="jour"
						id="jour"
						isInvalid={!!feedbackMessages['jour']}
						onChange={(e) => {
							setFeedbackMessages((prevMessages) => ({
								...prevMessages,
								jour: e.target.value
									? ''
									: "Le jour sélectionné n'est pas valide."
							}));
						}}
					>
						<option value="">Selectionner le jour</option>
						{DAYS_CHOICES.map((option, index) => (
							<option key={index} value={option.value}>
								{option.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['jour']}
					</Form.Control.Feedback>
				</Col>

				{/* Heure début et fin  */}
				{renderHeureDebutFin()}

				{/* Début et fin congés  */}
				{renderDateDebutFinConges()}

				{/* Salle de classe */}
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="salledeclasse">
						Salle de classe <span className="text-danger">*</span>
					</Form.Label>
					<Form.Select
						name="salledeclasse"
						required
						isInvalid={!!feedbackMessages['salledeclasse']}
						onChange={handleSalleDeclasseChange}
					>
						<option value="">Selectionner la salle de classe</option>
						{SALLEDECLASSE_CHOICES.map((choice, index) => (
							<option key={index} value={choice.value}>
								{choice.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['salledeclasse']}
					</Form.Control.Feedback>
				</Col>

				{renderMatiereField()}
				{renderCompetenceField()}

				{/* Examen */}
				<Col xs={12} className="mb-3">
					<Form.Label htmlFor="examen">Examen</Form.Label>
					<Form.Select
						name="examen"
						isInvalid={!!feedbackMessages['examen']}
						onChange={(e) => {
							const value = e.target.value;
							const feedbackMessage = value
								? ''
								: "L'examen sélectionné n'est pas valide.";
						}}
					>
						<option value="">Selectionner l'examen prévu</option>
						{EXAMEN_CHOICES.map((choice, index) => (
							<option key={index} value={choice.value}>
								{choice.label}
							</option>
						))}
					</Form.Select>
					<Form.Control.Feedback type="invalid">
						{feedbackMessages['examen']}
					</Form.Control.Feedback>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddEmploidutempsForm;
